import React from "react";
import OperatorSidebar from "./OperatorSidebar";

const OperatorLayout = () => {
  return (
    <div className="min-h-screen bg-gray-100">
      <OperatorSidebar />
    </div>
  );
};

export default OperatorLayout;
